import removePresenter from 'actions/source/removePresenter';
import { setScreenShare } from '@shoflo/studio-redux/actions/screenShare/setScreenShare';
import stopScreenShareIfLocal from '@shoflo/studio-redux/actions/screenShare/stopScreenShareIfLocal';

async function agoraScreenShareStopped({ getState, dispatch }, { attendeeId }) {
  dispatch(stopScreenShareIfLocal(attendeeId));
  const { broadcastSources } = getState();

  const source = broadcastSources?.sources?.find(s => s.value === attendeeId);

  if (source) {
    dispatch(removePresenter(attendeeId));
  }

  dispatch(setScreenShare(true));
}

export default agoraScreenShareStopped;
